import { AUTH_PATCH } from "@grudder/app/actions-client";
import { config } from "@grudder/lib/config";

// Common workflow status type
export type WorkflowStatus = "ACTIVE" | "PAUSED" | "DELETED";

// Common function to update workflow status
export const updateWorkflowStatus = async (workflowId: string, status: WorkflowStatus) => {
  return AUTH_PATCH(`${config.baseURL}/api/automations/${workflowId}`, { status });
};

// Specific helper functions (optional - for backwards compatibility)
export const pauseWorkflow = async (workflowId: string) => {
  return updateWorkflowStatus(workflowId, "PAUSED");
};

export const resumeWorkflow = async (workflowId: string) => {
  return updateWorkflowStatus(workflowId, "ACTIVE");
};

export const deleteWorkflow = async (workflowId: string) => {
  return updateWorkflowStatus(workflowId, "DELETED");
};